export const DEFAULT_PRACTICE_TIMEZONE = 'America/New_York';

export const VIEWPORT_ACTION_DISABLED_MESSAGE = "This action can't be used in the viewport.";

export const VIEWPORT_PRIVATE_TAG_DISABLED_MESSAGE = 'Admins can only create public tags.';

export const VIEWPORT_PRIVATE_TAG_EDIT_DISABLED_MESSAGE = "Admins cannot change tag's privacy.";

export const PRACTICE_ACCESS_REQUIRED_MESSAGE = 'This needs permission to view practices.';

export const BLOCKED_DIRECT_ADMIN_CODE = 30;

export const SUCCESS_CODE = 0;

export const NO_DATA_FOUND_CODE = 5;

export {
  employmentType,
  genders,
  marital_status,
  practice_kinds,
  practice_status,
  pronounOptions,
  races,
  tax_id_types
} from './demographics';

export {
  appointmentBalanceState,
  appointmentCCState,
  appointmentCheckinState,
  appointmentConfirmedOptions,
  appointmentDataTypeState,
  appointmentLengths,
  appointmentLocations,
  appointmentStatuses,
  appointmentTypes
} from './appointments';

export {
  clinicalNoteSections,
  clinicalNoteStatus,
  growthOptionChart,
  growthOptionGender,
  growthOptionMeasurement,
  howLongAgo,
  hpiContextList,
  hpiDurationList,
  hpiLocationList,
  hpiQualityList,
  hpiRelievingFactorList,
  hpiTimingList
} from './clinical/clinicalNotes';

export {
  allergies,
  diagnoses,
  diagnosisPointers,
  dosesList,
  frequencyCode,
  frequencyListDefault,
  medicalConditions,
  medications,
  otherProblemsList,
  patientReasons,
  surgeriesList,
  treatmentPlanProviderMethod,
  typicalReactions,
  vaccinesList,
  allergySeverities
} from './medical';

export {
  discountTypes,
  paymentMethods,
  paymentStatusOptions,
  paymentTypeOptions,
  serviceTypes
} from './billing/payments';

export {
  claim_md_employment_type,
  claim_md_genders,
  claim_md_marital_status,
  claimsStatusCodes,
  claimState,
  insurance_type,
  insurancePatientRelation,
  superbillStatus
} from './claim/claims';

export { chartLinks, defaultPracticeSettings, defaultSettings, selfScheduling } from './settings';

export {
  dateFormats,
  yesAndNoOptions,
  messageFilters,
  documentCategories,
  eps,
  intakeFormNameMapping,
  preferredHPFormNameMapping,
  preferredIntakeFormNameMapping,
  preferredProgressFormNameMapping,
  preferredSOAPFormNameMapping,
  progressFormNameMapping,
  soapFormNameMapping,
  tableNames,
  timeIncrements
} from './misc';

export {
  GENERIC_ERROR,
  GENERIC_ERROR_SUPPORT,
  EMAIL_INVALID,
  requiredMsg,
  savedMsg,
  createdMsg,
  updatedMsg,
  deletedMsg,
  failedMsg
} from './messages';
